import React from 'react';

import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';

export const CARD_RENDER_ERROR_MESSAGE = 'Unable to load customer information. Please close and try again.';

export const CustomerCardErrorAlert: React.FC<{ testId?: string }> = ({ testId = 'customer-card-error-boundary' }) => (
    <Alert type="error" data-testid={testId}>
        <Typography variant="body-sm" tag="span">
            {CARD_RENDER_ERROR_MESSAGE}
        </Typography>
    </Alert>
);
